// A zebra, modelled facing +X: a horse-shaped white body banded with black
// stripes, an upright mane and a tufted tail. Grazes the savanna. Ported 1:1
// from age-of-mcp's classic zebra.ts, restoring its leg loop + stripe loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.07, 0.03], [0.07, -0.03], [-0.07, 0.03], [-0.07, -0.03]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.008, 0.006, 0.13, 4),
      color: "#f4f4f0", position: [x!, 0.065, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#f6f6f2",
      position: [0, 0.13, 0], scale: [1.8, 1, 0.85] },               // body
    { geometry: new THREE.CylinderGeometry(0.02, 0.026, 0.08, 5), color: "#f6f6f2",
      position: [0.1, 0.16, 0], rotation: [0, 0, -0.7] },           // neck
    { geometry: new THREE.BoxGeometry(0.06, 0.028, 0.026), color: "#f6f6f2",
      position: [0.145, 0.19, 0] },                                  // head
    { geometry: new THREE.IcosahedronGeometry(0.01, 0), color: "#1a1a1a",
      position: [0.172, 0.185, 0] },                                 // muzzle
    { geometry: new THREE.BoxGeometry(0.01, 0.05, 0.03), color: "#1a1a1a",
      position: [0.085, 0.18, 0], rotation: [0, 0, -0.6] },         // mane
    { geometry: new THREE.CylinderGeometry(0.004, 0.012, 0.06, 4), color: "#1a1a1a",
      position: [-0.105, 0.1, 0], rotation: [0, 0, 0.5] },          // tail
  );
  // Black stripes — thin boxes wrapped over the body.
  for (let i = 0; i < 5; i++) {
    parts.push({ geometry: new THREE.BoxGeometry(0.012, 0.09, 0.088),
      color: "#1a1a1a", position: [-0.06 + i * 0.03, 0.13, 0] });
  }
  return parts;
}

export const zebra = defineModel({
  id: "zebra",
  scale: 2.68, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Zebra",
  tags: ["creature","zebra","low-poly","age-of-mcp","classic"],
  summary: "Low-poly zebra.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.15,
  parts: () => partsFor(),
  animations: [],
});
